export default "__VITE_ASSET__BNweL$_a__"